import React from 'react';
import { useRef, useState } from 'react';
import { debounce } from 'lodash';
import Quill from 'quill';
import Editor from './Editor';
import './StyleQuill.css';
const Delta = Quill.import('delta');

function QuillCo({ onTextChange, defaultContent }) {
        
        const [range, setRange] = useState();
        const [lastChange, setLastChange] = useState();
        const [readOnly, setReadOnly] = useState(false);

        const quillRef = useRef(null);
        React.useEffect(() => {
          if (quillRef.current) {
            quillRef.current.clipboard.dangerouslyPasteHTML(defaultContent || ''); // إدخال النص من قاعدة البيانات
          }
        }, [defaultContent]);
      
        React.useEffect(() => {
          if (quillRef.current) {
            const debouncedChangeHandler = debounce(() => {
              if (quillRef.current && quillRef.current.root) {
                const content = quillRef.current.root.innerHTML;
                onTextChange(content);
              }
            }, 2000);
        
            quillRef.current.on('text-change', debouncedChangeHandler);
        
            // تنظيف عند إزالة المكون
            return () => {
              quillRef.current.off('text-change', debouncedChangeHandler);
            };
          } else {
            console.warn("quillRef.current غير موجود داخل useEffect");
          }
        }, [onTextChange]);
        

  return (
    <div>
      <Editor
        ref={quillRef}
        readOnly={readOnly}
        defaultValue={new Delta()
          .insert('Hello')
          .insert('\n', { header: 1 })
          .insert('Some ')
          .insert('initial', { bold: true })
          .insert(' ')
          .insert('content', { underline: true })
          .insert('\n')}
        onSelectionChange={setRange}
        onTextChange={setLastChange}
      />
      {/* <div className="controls">
        <label>
          Read Only:{' '}
          <input
            type="checkbox"
            value={readOnly}
            onChange={(e) => setReadOnly(e.target.checked)}
          />
        </label>
        <button
          className="controls-right"
          type="button"
          onClick={() => {
            alert(quillRef.current?.getLength());
          }}
        >
          Get Content Length
        </button>
      </div> */}
      {/* <div className="state">
        <div className="state-title">Current Range:</div>
        {range ? JSON.stringify(range) : 'Empty'}
      </div>
      <div className="state">
        <div className="state-title">Last Change:</div>
        {lastChange ? JSON.stringify(lastChange.ops) : 'Empty'}
//       </div> */}
    </div>
  );
};


export default QuillCo;

